import React from "react";
import OrdersList from "../../components/Orders/OrdersList";

const HivesOrdersScreen = () => {
  return <OrdersList />;
};

export default HivesOrdersScreen;
